import { ICashManagementClient } from './ICashManagementClient';
import { CashManagementClientMocked } from './cashManagementClientMocked';

// Toggle between real API and mocked data
const USE_REAL_API = false;

// Factory function to get the appropriate client
export const getCashManagementClient = (): ICashManagementClient => {
  if (USE_REAL_API) {
    // TODO: Return real API client when backend is ready
    // return new CashManagementClientApi();
    throw new Error('Real API not implemented yet');
  }
  return new CashManagementClientMocked();
};

// Re-export types for convenience
export * from './cashManagementTypes';
export type { ICashManagementClient } from './ICashManagementClient';
